import {OrderCommentCommand} from './OrderCommentCommand';

export interface OrderRepository {
  cancelOrder(): Promise<Record<string, boolean>>;
  updateOrderComment(comment: OrderCommentCommand): Promise<Record<string, boolean>>;
}
